module.exports = __webpack_public_path__ + "img/orange-clock.c9a62a40.svg";